import React, { Component } from 'react'
import * as R from "ramda";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { configTeamLeaderReportStatistic } from '../config'
import { HttpStatus } from "../../../../../common/Constants";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { mapToObjectDDL, removeNullFields } from "../../../../../common/mapper";

export default class TeamLeaderProspectReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableConfig: [],
      dataTable: [],
    };
  }

  componentDidMount() {
    this.setState((prevValue) => ({
      ...prevValue,
      tableConfig: configTeamLeaderReportStatistic,
    }));
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch === true) {
      this.fetchData(this.props.search);
    }
  };

  fetchData = async (payload) => {
    const userId = localStorage.getItem("userId");
    this.props.triggerLoading(true);
    const request = {
      kodeCabangList: payload.kodeCabangList,
      teamLeaderEmployeeId: userId,
      salesEmployeeId: null,
      month: payload.month,
      year: payload.year
    };
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikTeamLead,
      menuName: "Dashboard Koordinator - Laporan Statistik Prospek Per Team Lead",
      setError: this.props.setError,
      args: request,
    });
    this.props.onSuccessSearch();
    if (res?.data?.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data || [],
      }));
    }
    this.props.triggerLoading(false);
  };

  render() {
    return (
      <div style={{ padding: 10 }}>
        <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>LAPORAN STATISTIK PROSPEK PER TEAM LEADER</p>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
          rowsPerPage={5}
          page={0}
          options={{serverSide: false}}
        />
      </div>
    )
  }
}
